import {useQuery} from '@tanstack/react-query'
import {ShadowViewTopItem} from 'interfaces'
import _keyBy from 'lodash.keyby'
import _merge from 'lodash.merge'
import {useSelector} from 'react-redux'
import {AnalyticsService, ShadowFinderService} from 'services/api'
import {selectShadowITSearchQuery} from '../../analyticsShadowITSelectors'
import {appRenameMap} from '../../constants'

const QUERY_KEY = 'getShadowITTopApps'
export const useShadowITTopAppsQuery = () => {
  const shadowITSearchQuery = useSelector(selectShadowITSearchQuery)

  const {
    data: shadowTopAppsQueryState = [],
    status: shadowTopAppsQueryStatus,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [
      QUERY_KEY,
      shadowITSearchQuery?.searchType,
      shadowITSearchQuery?.searchTerm,
    ],
    queryFn: () =>
      shadowITTopAppsQueryFn(
        shadowITSearchQuery?.searchType,
        shadowITSearchQuery?.searchTerm,
      ),
  })

  return {
    shadowTopAppsQueryState,
    shadowTopAppsQueryStatus,
    isLoading,
    isError,
  }
}

export const shadowITTopAppsQueryFn = async (
  searchType: string,
  searchTerm: string,
): Promise<ShadowViewTopItem[]> => {
  try {
    const [{data: _volumeData}, {data: _loginsData}] = await Promise.all([
      AnalyticsService.getShadowITOverviewVolumes(searchType, searchTerm),
      ShadowFinderService.getShadowITOverviewLogins(searchType, searchTerm),
    ])
    // there are couple of apps which UI will rename
    const loginsData =
      _loginsData?.data?.apps?.map(item => ({
        ...item,
        name: appRenameMap[item.appName] || item.appName,
      })) || []
    const volumeData =
      _volumeData?.data?.apps?.map(item => ({
        ...item,
        name: appRenameMap[item.appName] || item.appName,
      })) || []
    const mergedData = _merge(
      _keyBy(volumeData, 'name'),
      _keyBy(loginsData, 'name'),
    )
    const shadowLoginApps = loginsData.map(item => {
      const node = mergedData[item.name]
      delete mergedData[item.name]
      return node
    })
    const otherCloudApps = Object.values(mergedData).sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    )

    return [...shadowLoginApps, ...otherCloudApps].filter(item => item.name)
  } catch (error) {
    // rejected promise with error
    return Promise.reject(error)
  }
}
